import { useUser } from '../../generic/hooks/useUser'

const useFormUtils = () => {
  const { user } = useUser()
  return {
    isEjercito: user?.profile?.code === 'EJERCITO'
  }
}

export default useFormUtils
